// src/components/SearchBar.jsx
import React, { useState } from "react";
import "./Styles/SearchBar.scss";

const SearchBar = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    onSearch(searchQuery);
  };

  return (
    <section className="search-bar">
      <input
        type="text"
        placeholder="Search by author, title, or year"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <button onClick={handleSearch}>Search</button>
    </section>
  );
};

export default SearchBar;
